import { compareDates } from '@/common/functions/compareDates';

export const sortTickets = (tickets) =>
	tickets.sort((ticketA, ticketB) =>
		compareDates(
			new Date(ticketA.valid_invoice.sold_date),
			new Date(ticketB.valid_invoice.sold_date),
		),
	);
